import { Brand, UppMonitoringService } from '@mamdev/navigator.epimetheus'
import { UppClientOptions } from '../../interfaces'
import { Portal } from '../../../interfaces'
import { error } from '@mamdev/navigator.frontend-logger'

export let monitoringService: UppMonitoringService | undefined

export function initMonitoringService(options: UppClientOptions) {
  try {
    monitoringService = new UppMonitoringService({
      brand: getMonitoringBrand(options.portal),
      stage: options.stage,
      metaData: {
        section: getMonitoringSection(options),
        client: 'latest',
      }
    })
  } catch (e) /* istanbul ignore next */ {
    error('initMonitoringService failed', e)
  }
}

export function getMonitoringBrand(portal: Portal): Brand {
  switch (portal) {
    case 'gmx':
    case 'gmxat':
    case 'gmxch':
      return 'gmx'
    default:
      return portal
  }
}

export function getMonitoringSection(options: UppClientOptions): string {
  return typeof options?.section === 'string' ? options.section.split('/')[0]:
    options?.category
}
